import { useEffect } from 'react';

import isScrollbarVisible from '@utils/ScrollbarVisible';

export type LoadMoreIfNecessary = {
    hasNextPage: boolean;
    isLoading: boolean;
    fetchNextPage: () => void;
};

const useLoadMoreIfNecessary = (
    { hasNextPage, isLoading, fetchNextPage }: LoadMoreIfNecessary,
    // pass in the data array from the pagination hook so that we can trigger the refresh again if we need to get call another page
    depsArray: unknown[],
) => {
    // If we're at the top of the page and there are more pages, and we cannot scroll, fetch next page
    useEffect(() => {
        const atTop = window.pageYOffset === 0;
        if (hasNextPage && atTop && !isLoading && !isScrollbarVisible()) {
            fetchNextPage();
        }
    }, [fetchNextPage, hasNextPage, isLoading, ...depsArray]);
};

export default useLoadMoreIfNecessary;
